import React, { Component } from 'react';
import { withStyles } from '@material-ui/core';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import {  Cookies } from 'react-cookie';
import ChangeElevatorUses from './ChangeElevatorUses';
import ChangeElevatorCoverage from './ChangeElevatorCoverage';
import ChangePriceElevator from './ChangePriceElevator';
import ChangeElevatorKind from "./ChangeElevatorKind";
import ChangeElevatorKindDoor from "./ChangeElevatorKindDoor";
import ChangeElevatorKindRespons from "./ChangeElevatorKindRespons";



const styles = theme => ({
  paperrtl: {
    marginTop: theme.spacing(0),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  }
  , paper: {
      display: 'flex',
      flexWrap: 'wrap',
      '& > *': {
        margin: theme.spacing(1),
        width: theme.spacing(20),
      },
    },


});

class ChangeElevator extends Component {
  cookies=new Cookies();
  constructor(props) {
      super(props);
    this.state = {
  value:0,
}}

componentDidMount() {

}
handleChange= (event,newValue) => {
  this.setState({ value:newValue });
}
    render() {
      const { classes } = this.props;
      const { value } = this.state;

        return (
            <div>
                 <AppBar position="sticky"color="primary" >

                   <Tabs
                    style={{height:'60px',textAlign:'center'}}
                     value={value}
                     onChange={this.handleChange}
                     indicatorColor="secondary"
                     textColor={'#000000'}
                     variant="scrollable"
                     scrollButtons="auto"
                     aria-label="scrollable auto tabs example"
                   >
                     <Tab label="کاربری ساختمان"  />
                     <Tab label="پوشش بیمه آسانسور"  />
                       {/*<Tab label="نوع در آسانسور"  />*/}
                       <Tab label="نوع  آسانسور"  />
                     <Tab label="نوع مسئولیت آسانسور"  />
                     <Tab label="قیمت بیمه آسانسور "  />
                     </Tabs>


                 </AppBar>
                 {(value===0)?<ChangeElevatorUses  props={this.props}/>:null}
                {(value===1)?<ChangeElevatorCoverage  props={this.props}/>:null}
                {/*{(value===2)?<ChangeElevatorKindDoor  props={this.props}/>:null}*/}
                 {(value===2)?<ChangeElevatorKind  props={this.props}/>:null}
                 {(value===3)?<ChangeElevatorKindRespons  props={this.props}/>:null}
                 {(value===4)?<ChangePriceElevator  props={this.props}/>:null}

               </div>
        );
    }
}

export default  withStyles(styles)(ChangeElevator);
